import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon, FlaskConicalIcon, BlocksIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
const PROMPT_LABS_IMG = 'https://cdn.magicpatterns.com/uploads/5Q9RfJNAqY4CyZrnPn4qcW/mk-principal.png?w=560&q=70&fm=webp';
const notThis = ['Otro curso de teoría sobre IA', 'Una lista de 5,000 prompts inútiles que podrías encontrar en Google'];
const butThis = ['Un Manual de Ingeniería Humana diseñado para obligar a la IA a trabajar bajo tus reglas', 'Un sistema de "Llenado de Espacios" que funciona para cualquier nicho'];
export function Mechanism() {
  return <section className="relative w-full overflow-hidden bg-ink-900 py-12 sm:py-16" data-id="element-147">
      <div className="absolute inset-0 bg-lab-grid opacity-30" aria-hidden="true" data-id="element-148" />
      <div className="relative mx-auto max-w-6xl px-5" data-id="element-149">
        <SectionHeading eyebrow="La Revelación" data-id="element-150">
          Presentamos PROMPT LABS <span className="text-accent" data-id="element-151">+</span> El
          Ecosistema Nano-Creative
        </SectionHeading>

        <div className="mt-8 grid items-center gap-8 lg:grid-cols-2" data-id="element-152">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.7
        }} className="relative mx-auto w-full max-w-sm" data-id="element-153">
            <div className="absolute inset-0 -z-10 scale-90 rounded-full bg-accent/20 blur-3xl" aria-hidden="true" data-id="element-154" />
            <img src={PROMPT_LABS_IMG} alt="Ebook PROMPT LABS sobre un pedestal de laboratorio" width={560} height={560} className="w-full rounded-2xl shadow-card ring-1 ring-white/10 animate-float" loading="lazy" decoding="async" data-id="element-155" />
          </motion.div>

          <div className="space-y-4" data-id="element-156">
            <Reveal data-id="element-157">
              <div className="rounded-2xl border border-urgency/20 bg-urgency/5 p-5" data-id="element-158">
                <h3 className="mb-3 flex items-center gap-2 text-sm font-bold uppercase tracking-wide text-urgency" data-id="element-159">
                  <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-160" /> No es
                </h3>
                <ul className="space-y-2" data-id="element-161">
                  {notThis.map(t => <li key={t} className="flex items-start gap-2 text-sm text-silver/70" data-id="element-162">
                      <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-urgency/70" aria-hidden="true" data-id="element-163" />
                      {t}
                    </li>)}
                </ul>
              </div>
            </Reveal>

            <Reveal delay={0.1} data-id="element-164">
              <div className="rounded-2xl border border-accent/30 bg-accent/5 p-5 shadow-glow-cyan" data-id="element-165">
                <h3 className="mb-3 flex items-center gap-2 text-sm font-bold uppercase tracking-wide text-accent-light" data-id="element-166">
                  <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-167" /> Es
                </h3>
                <ul className="space-y-2" data-id="element-168">
                  {butThis.map(t => <li key={t} className="flex items-start gap-2 text-sm text-silver/85" data-id="element-169">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-accent" aria-hidden="true" data-id="element-170" />
                      {t}
                    </li>)}
                </ul>
              </div>
            </Reveal>

            <Reveal delay={0.2} data-id="element-171">
              <div className="grid grid-cols-2 gap-3 pt-1" data-id="element-172">
                <div className="rounded-xl border border-white/5 bg-ink-800/60 p-4 text-center" data-id="element-173">
                  <FlaskConicalIcon className="mx-auto h-6 w-6 text-accent" aria-hidden="true" data-id="element-174" />
                  <p className="mt-2 text-xs text-silver/70" data-id="element-175">
                    Meses de pruebas destilados
                  </p>
                </div>
                <div className="rounded-xl border border-white/5 bg-ink-800/60 p-4 text-center" data-id="element-176">
                  <BlocksIcon className="mx-auto h-6 w-6 text-accent" aria-hidden="true" data-id="element-177" />
                  <p className="mt-2 text-xs text-silver/70" data-id="element-178">
                    Desde un taller mecánico hasta una agencia de 7 cifras
                  </p>
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>;
}